
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"-6 -6 36 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#B53426","d":"M16 16a2 2 0 01-2 2H2a2 2 0 01-2-2V8a2 2 0 012-2h12a2 2 0 012 2v8zm8-10l-6 4.223v3.554L24 18V6z"}})])
          )
        }
      }
    